/**
 * Kredi kartı numarası için mask belirleme utility fonksiyonu
 * @param cardNumber - Kart numarası
 * @returns Uygun mask string'i
 */
export const getCreditCardMask = (cardNumber: string): string => {
  // 14-19 haneli kartlar için
  return '9999 9999 9999 9999 999'; // userCardNo19
};

/**
 * Kart numarasının geçerli uzunlukta olup olmadığını kontrol eder
 * @param cardNumber - Kontrol edilecek kart numarası
 * @returns Geçerli uzunlukta ise true
 */
export const isValidCardLength = (cardNumber: string): boolean => {
  const cleanNumber = cardNumber.replace(/\s/g, '');
  return cleanNumber.length >= 14 && cleanNumber.length <= 19;
};

/**
 * Kart numarasından sadece rakamları çıkarır
 * @param cardNumber - Formatlanmış kart numarası
 * @returns Sadece rakamlardan oluşan string
 */
export const extractCardNumbers = (cardNumber: string): string => {
  return cardNumber.replace(/\D/g, '');
};

/**
 * Kart numarasına göre CVV mask döndürür
 * 16 haneli kartlar için 3 haneli, diğerleri için 4 haneli CVV
 * @param cardNumber - Kart numarası
 * @returns CVV mask string'i
 */
export const getCvvMask = (cardNumber: string): string => {
  const cleanNumber = cardNumber.replace(/\s/g, '');
  return cleanNumber.length === 16 ? '999' : '9999';
};

/**
 * Kart numarasına göre CVV maksimum uzunluğunu döndürür
 * 16 haneli kartlar için 3, diğerleri için 4
 * @param cardNumber - Kart numarası
 * @returns CVV maksimum uzunluğu
 */
export const getCvvMaxLength = (cardNumber: string): number => {
  const cleanNumber = cardNumber.replace(/\s/g, '');
  return cleanNumber.length === 16 ? 3 : 4;
};
